import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-validation-error',
    templateUrl: './validation-error.component.html',
    styleUrls: ['./validation-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ValidationErrorComponent {
  @Input() error: string;
}
